export default "__VITE_ASSET__dAnHfYaE__"